import { translateFr as tfr } from "@/i18n";
export const DSTATE = {
  ACTIVE: { label: "Active", chip: "bg-success/10 text-success border-success/30", dot: "bg-success" },
  ATTENTION: { label: tfr("À surveiller"), chip: "bg-warning/10 text-warning border-warning/30", dot: "bg-warning" },
  BLOCKED: { label: tfr("Bloquée"), chip: "bg-athlynx/10 text-athlynx border-athlynx/30", dot: "bg-athlynx" },
};

export const MILESTONES = [
  { id: "FIRST_CONTACT", label: tfr("Premier échange") },
  { id: "NEED_IDENTIFIED", label: tfr("Besoin identifié") },
  { id: "MEETING", label: "Rendez-vous" },
  { id: "REPRESENTATION_PROPOSAL", label: tfr("Proposition de représentation") },
  { id: "DECISION", label: tfr("Décision") },
];

export const INTERLOCUTOR_ROLES = [
  "Père", "Mère", "Tuteur", "Famille", "Avocat", "Conseiller",
  "Coach", "Directeur sportif", "Représentant club", "Intermédiaire", "Autre",
];
